export const patientActions = {
  populatePatients: "POPULATE_PATIENTS",
  patientsLoading: "DATA_PATIENTS_LOADING",
  patientsLoadError: "DATA_PATIENTS_LOAD_ERROR"
};
